import React, { Component } from "react";

import InboomaReactModelView from "../integration/InboomaReactModelView";
import Order from "../../models/Order";

// "templateContext" for React components
import Rbac from "../../utils/Rbac";
import InboomaBaseView from "../../views/InboomaBaseView";

const t = InboomaBaseView.prototype.t,
  rbac = new Rbac(Order);

class OrderListItem extends InboomaReactModelView {
  render() {
    return (
      <div className="inb-c-item inb-c-item--order row">
        <div className="medium-12 column text-center">
          <h5>OrderListItem (#{this.model.get("id")}, react-component)</h5>
        </div>

        <div className="medium-4 column">
          <strong>Read</strong> from model: &#10004;
          <br />
          <br />
          <span>
            - order.price: {this.model.get("price")} <br />- order.status:{" "}
            {this.model.get("status")} <br />- order.order_nbr: {this.model.get("order_nbr")} <br />
            - order.reservations.length {this.model.get("reservations").length}
          </span>
        </div>

        <div className="medium-4 column">
          <strong>Translate</strong> string: &#10004;
          <br />
          <br />- &quot;{t("order")}&quot; <br />- Parametisierter String: &quot;
          {t("toggle_${a}_view", { a: t("list") })}&quot;
        </div>

        <div className="medium-4 column">
          Show/hide container via <strong>rbac</strong>: &#10004;
          <br />
          <br />
          {rbac.hasPermission("write") && (
            <div className="secret-container">I am only visible for user with write access</div>
          )}
        </div>
      </div>
    );
  }
}

export default class DemoOrdersPage extends Component {
  componentDidMount() {
    console.log("DEMO ORDER LIST STATE", this);
  }

  render() {
    return (
      <div>
        {this.props.orders.map((order) => (
          <OrderListItem model={order} key={order.get("id")} />
        ))}
      </div>
    );
  }
}
